import { PARKING_LOT_GRID_COLUMN_PX } from 'app/components/RoadmapCard/parkingLotLayoutConstants';

export interface MonthlyTooltipPlacement {
  vertical: 'top' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
}

function calculateVerticalPosition(
  elementRect: DOMRect,
  containerRect: DOMRect,
  safetyMargin = 20
): 'top' | 'bottom' {
  const spaceBelow = containerRect.bottom - elementRect.bottom - safetyMargin;
  const spaceAbove = elementRect.top - containerRect.top - safetyMargin;

  return spaceAbove > spaceBelow ? 'top' : 'bottom';
}

function calculateHorizontalPosition(
  elementRect: DOMRect,
  tooltipWidth: number,
  availableWidth: number,
  safetyMargin = 20
): 'left' | 'center' | 'right' {
  const wouldOverflowRight = elementRect.left + tooltipWidth > availableWidth;
  const wouldOverflowLeft = elementRect.right - tooltipWidth < safetyMargin;

  if (wouldOverflowRight && !wouldOverflowLeft) {
    return 'right';
  }

  if (wouldOverflowRight && wouldOverflowLeft) {
    const centerPosition =
      elementRect.left + elementRect.width / 2 - tooltipWidth / 2;

    if (
      centerPosition >= safetyMargin &&
      centerPosition + tooltipWidth <= availableWidth
    ) {
      return 'center';
    }

    const spaceLeft = elementRect.left - safetyMargin;
    const spaceRight = availableWidth - elementRect.right;
    return spaceLeft > spaceRight ? 'right' : 'left';
  }

  return 'left';
}

export function calculateMonthlyTooltipPosition(
  element: HTMLDivElement | null,
  tooltipHeight: number,
  tooltipWidth = 400,
  showParkingLot = false
): MonthlyTooltipPlacement {
  if (!element) {
    return { vertical: 'top', horizontal: 'left' };
  }

  const rect = element.getBoundingClientRect();
  const container = document.querySelector(
    '[data-testid="monthly-roadmap-scroll-area"]'
  );
  const containerRect = container?.getBoundingClientRect();

  if (!containerRect) {
    return { vertical: 'bottom', horizontal: 'left' };
  }

  const safetyMargin = 20;
  const parkingLotWidth = showParkingLot ? PARKING_LOT_GRID_COLUMN_PX : 0;
  const availableWidth = window.innerWidth - safetyMargin - parkingLotWidth;

  return {
    vertical: calculateVerticalPosition(rect, containerRect, safetyMargin),
    horizontal: calculateHorizontalPosition(
      rect,
      tooltipWidth,
      availableWidth,
      safetyMargin
    )
  };
}
